module.exports = __webpack_public_path__ + "static/media/wavm8s-024-fragile.525d96a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-024-fragile.mp3
// module id = vS4m
// module chunks = 0